import React, { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { FaUser, FaCalendar } from 'react-icons/fa';
import '../styles/projectCard.css';

function ProjectCard({ project, provided, snapshot, onClick }) {
  const [tasks, setTasks] = useState([]);
  const [responsible, setResponsible] = useState(null);

  // Hent opgaver for projektet
  useEffect(() => {
    const q = query(
      collection(db, 'tasks'),
      where('projectId', '==', project.id)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const tasksData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setTasks(tasksData);
    });

    return () => unsubscribe();
  }, [project.id]);

  // Hent ansvarlig bruger
  useEffect(() => {
    if (!project.responsible) return;

    const unsubscribe = onSnapshot(doc(db, 'users', project.responsible), (doc) => {
      if (doc.exists()) {
        setResponsible(doc.data());
      }
    });

    return () => unsubscribe();
  }, [project.responsible]);

  const completedTasks = tasks.filter(task => task.completed).length;
  const totalTasks = tasks.length;
  const progress = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

  const getDeadlineStatus = (deadline) => {
    if (!deadline) return null;
    
    const today = new Date();
    const deadlineDate = new Date(deadline);
    const daysUntilDeadline = Math.ceil((deadlineDate - today) / (1000 * 60 * 60 * 24));
    
    if (daysUntilDeadline < 0) {
      return 'overdue';
    } else if (daysUntilDeadline <= 3) {
      return 'warning';
    }
    return null;
  };

  const deadlineStatus = getDeadlineStatus(project.deadline);

  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className={`project-card ${snapshot.isDragging ? 'dragging' : ''} ${deadlineStatus || ''}`}
      onClick={onClick}
    >
      <div className="project-card-header">
        <h3>{project.name}</h3>
        <div className="project-meta">
          {responsible && (
            <div className="project-responsible">
              <FaUser />
              <span>{responsible.name || responsible.email}</span>
            </div>
          )}
          {project.deadline && (
            <div className={`project-deadline ${deadlineStatus || ''}`}>
              <div className="deadline-indicator" />
              <FaCalendar />
              <span>{new Date(project.deadline).toLocaleDateString('da-DK')}</span>
            </div>
          )}
        </div>
      </div>

      <div className="project-progress">
        <div className="progress-numbers">
          <span className="tasks-count">{completedTasks}/{totalTasks} opgaver</span>
          <span className="progress-percentage">{Math.round(progress)}%</span>
        </div>
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
